/**
 * Game-related translations for English language
 * This file contains translations for game mechanics, stages, and end reasons
 */
export default {
  game: {
    winner: 'Winner',
    evil: 'evil',
    good: 'good',
    stage: 'stage',
    voteStage: 'Vote stage',
    voting: 'voting',
    excalibur: 'excalibur',
    'team building': 'team building',
    mission: 'mission',
    initialization: 'initialization',
    'lady of lake': 'lady of lake',
    'check loyalty': 'check loyalty',
    'witch loyalty': 'witch loyalty',
    'announce loyalty': 'announce loyalty',
    'give card': 'give card',
    'lead to victory': 'lead to victory',
    'restore honor': 'restore honor',
    'king returns': 'king returns',
    'play card': 'play card',
    'reveal loyalty': 'reveal loyalty',
    'we found you': 'we found you',
    ambush: 'ambush',
    end: 'end',
    lancelots: 'lancelots',
    witch: 'witch',
    assassinate: 'assassinate',
    hidden: 'hidden',
    historyMode: 'History mode',
    gameIsEnded: 'Game is ended',
    rolesAndAddons: 'Roles and addons',
  },
  endReason: {
    manualy: 'The game is finished manually',
    evilTeamMissions: 'The evil team failed 3 missions',
    goodTeamMissions: 'The good team successes 3 missions',
    missMerlin: 'The evil team tried to kill Merlin but missed',
    missGuinevere: 'The evil team tried to kill Guinevere but missed',
    missLovers: 'The evil team tried to kill Lovers but missed',
    missCleric: 'The evil team tried to kill Cleric + 1 but missed',
    killCleric: 'The evil team to killed Cleric + 1',
    killGuinevere: 'The evil team killed Guinevere',
    killLovers: 'The evil team killed Lovers',
    killMerlin: 'The evil team killed Merlin',
    rejectedVote: 'The evil team sabotaged the voting',
  },
};
